<template>
    <li class="campaign_type" :class="isActive ? 'active_type':''" :key="item.title" @click="onClick(item)">
        <div class="type_icon">
            <div v-html="item.icon"></div>
        </div>
        <div class="type_body">
            <h3 class="font_regular name">{{item.title}}</h3>
            <p class="font_regular description">{{item.description}}</p>
        </div>
    </li>
</template>

<script>
export default {
    props:{
        item:{
            type: Object,
            default: ()=>({}),
        },
        isActive:{
            type: Boolean,
            default: false,
        }
    },
    methods:{
        onClick(item){
            this.$emit('onClick',item)
        },
    },
}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';
.campaign_type{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    justify-content: center;
    width: 280px;
    height: 240px;
    border: 1px solid #EEEEEE;
    border-radius: 10px;
    padding: 20px;
    margin: 24px 0 0 0;
    cursor: pointer;
    transition:  all ease-in-out 0.2s;

    .type_body{
        margin-top: 16px;
        text-align: center;
        .name{
            // @extend .common_font;
            font-weight: 600;
            font-size: 16px;
            color: #000;
        }
        .description{
            // @extend .common_font;
            font-weight: 500;
            font-size: 14px;
            color:#858585;
            margin-top: 4px;
        }
    }
}
.active_type{
    border: 2px solid #8D25F6;
    transition:  all ease-in-out 0.2s;
}
</style>